// window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
require('./front_end_api/index');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-Team-ID'] = window.$jBoard.team ? window.$jBoard.team.id : null;
window.axios.defaults.headers.common['X-CURRENT-EMPLOYER-ID'] = window.$jBoard.currentUser ? window.$jBoard.currentUser.current_employer_id : null;

if (window.$jBoard.config.custom_tenant_api_url) {
  axios.defaults.baseURL = window.$jBoard.config.custom_tenant_api_url;
  axios.defaults.headers.common['X-CSRF-TOKEN'] = window.$jBoard.csrf_token;
}

if (window.$jBoard.currentSessionID) {
  window.axios.defaults.headers.common['X-SESSION-ID'] = window.$jBoard.currentSessionID;
}

if (window.$jBoard.adminUserToken) {
  window.axios.defaults.headers.common['X-ADMIN-USER-TOKEN'] = window.$jBoard.adminUserToken;
}

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
window.axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response === undefined) {
    return Promise.reject(error);
  }

  switch (error.response.status) {
    case 401:
    case 419:
      if (error.response.data.message === 'current_employer_changed') {
        $('#modal-current-employer-changed').modal('show');
      } else {
        $('#modal-session-expired').modal('show');
      }
      break;
  }

  return Promise.reject(error);
});

window.$ = window.jQuery = require('jquery');
require('bootstrap/js/src/modal');
// require('bootstrap/js/src/carousel');
require('bootstrap/js/src/dropdown');
require('bootstrap/js/src/tab');
require('form-serializer');
require('./utils/loading');
require('./utils/simpleSubmitForm');
require('./utils/analytics');

window.$(() => {
  const tooltips = $('[data-toggle="tooltip"]');
  if (tooltips.length) {
    tooltips.tooltip({
      template: '<div class="tooltip jb-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    });
  }
});

window.$('[data-toggle="collapse"]').click(function(){
  var self = $(this);
  $( self.data('target') ).stop().slideToggle('fast');
  self.toggleClass('open');
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
